export default __webpack_public_path__ + "static/video-2-poster-1c55eaf1dd66881e0d45e0728ba27f10.png";